//import styles from "./About.module.sass";
//import cn from "classnames";
//import { axiosInstance } from "../../utils/API";
//import { PopUpAlert } from "../../controller/utils";
//import { useEffect, useState } from "react";
//import Popular from "../Home/Popular";
//import RecentSold from "../Home/RecentSold";
//            <RecentSold color="#f5f5f5" textColor="#000000"></RecentSold>
import RealSplitNews from "./RealSplitNews";
import RealSplitNewsList from "./RealSplitNewsList";
import { useNavigate } from "react-router-dom";

//const News = () => {
const News = (props) => {
    console.debug('News(props)', props);

    //const [about, setAbout] = useState(null);
    const navigate = useNavigate()
    // useEffect(() => {
    //   axiosInstance.get('/webcontent?key=about_us').then((res) => {
    //     setAbout(res?.data?.result[0]);
    //   }).catch((err) => {
    //     PopUpAlert("Alert", err?.data?.response?.error ? err?.data?.response?.error : err.message, "error")
    //   })
    // }, []);
    const redirectNft = () => {
        navigate('/search/all')
    }

    return (
        
        <main className = 'item-main edit-profile about'>
            <section
                //className={styles.aboutsection}
                className = 'form property-information'
                //className = 'form'
                style = {{
                    paddingTop: "0px"
                    , paddingBottom: "80px"
                }}
                >
                <div
                    className = { 'max-width' }
                    style = {{ paddingLeft: '0px', paddingRight: '0px' }}
                    >
                    <div
                        //className = 'flex-container'
                        className = { 'property-information' }
                        style = {{
                            //textAlign: "left"
                            //border: 'blue 2px solid'
                            paddingBottom: '0px'
                        }}
                        >

                        {
                            props.urlSlug
                            ? <RealSplitNews
                                urlSlug = { props.urlSlug }
                                />
                            : <RealSplitNewsList
                                urlSlug = { props.urlSlug }
                                />
                        }
                        
                    </div>
                </div>
            </section>

        </main>
        
    );
};

export default News;
